import PlayerAnimations from "./PlayerAnimations";
import { loader } from "../utils/assetLoader";
import { lionIdles, lionJump, lionRoar, lionWalk } from "../utils/assets";
import ScorePickup from "./PickupAnimation";
import { getElem, pause } from "../utils";

class Player {
    constructor(app, engine, config) {
        this.app = app;
        this.engine = engine;
        this.config = config;
        this.size = 60;
        this.curAnim = null;
        this.body = null;
        this.container = null;
        this.ScorePickup = null;
        this.jumping = false;
        this.grounded = true;

        this.allowJump = true;
        this.allowMove = true;

        this.soundHead = getElem('gauge-circle-lionHead');
        lionRoar.then();

        this.initialX = 100;
        this.initialY = 150;
        let minSize = this.size*2;
        this.anims = {
            idle: new PlayerAnimations(0, lionIdles, minSize, true),
            jump: new PlayerAnimations(-25, lionJump, minSize),
            // roar: new PlayerAnimations(-25, lionRoar, minSize),
            walk: new PlayerAnimations(-25, lionWalk, minSize),
        }

        
    }

    create(onGrounded, adjust) {
        // Create anims
        this.container = new PIXI.Container();
        this.ScorePickup = new ScorePickup(this.container);

        let minSize = this.size*2;
        let maxSize = this.size*2.1;

        this.container.x -= this.size/2;
        this.container.y -= this.size/2;
        this.app.stage.addChild(this.container);
        
        for (const key in this.anims) {
            this.container.addChild(this.anims[key].getSprites());
        }

        this.curAnim = this.anims.idle;
        setTimeout(() => {
            this.curAnim.play();
        }, 500)
        
        // Create physics body
        let posX = adjust ? 
            adjust + this.initialX + this.size / 2:
            this.initialX + this.size / 2;

        this.body = Matter.Bodies.rectangle(
            posX,
            this.initialY + this.size / 2,
            this.size * 0.8,
            this.size * 0.8,
            { 
                friction: 0.01,
                restitution: 0.1,
                density: 0.05
            }
        );
        
        Matter.Composite.add(this.engine.world, this.body);
        
        // Add collision detection for ground check
        this.setupCollisionDetection(onGrounded);
        
        return this;
    }

    spawnScoreEff(text) {
        this.ScorePickup.spawnScoreEff(text);
    }

    setupCollisionDetection(onGrounded) {
        // Matter.Events.on(this.engine, 'beforeUpdate', (event) => {
        //     const pairs = Matter.Query.collides(this.body, this.engine.world.bodies);
            
        //     for (const pair of pairs) {
        //         if (pair.bodyA === this.body || pair.bodyB === this.body) {
        //             const otherBody = pair.bodyA === this.body ? pair.bodyB : pair.bodyA;
        //             // console.log(otherBody.label);
                    
        //             if (otherBody.label === "floater") {
        //                 // Only allow collision if player is falling and approaching from above
        //                 const playerBottom = this.body.bounds.max.y;
        //                 const platformTop = otherBody.bounds.min.y;
        //                 const playerVelocity = this.body.velocity.y;
                        
        //                 // Check if player is falling (positive Y velocity) and close to platform top
        //                 if (Math.abs(playerBottom - platformTop) < 0) {
        //                     console.log("above!");
        //                     otherBody.isSensor = false;
        //                 } else {
        //                     // Disable the collision for one-way platforms when jumping up
        //                     console.log("below!");
        //                     otherBody.isSensor = true;
        //                 }
        //             }
        //         }
        //     }
        // })
        Matter.Events.on(this.engine, 'collisionStart', (event) => {
            const pairs = event.pairs;
            
            for (const pair of pairs) {
                if (pair.bodyA === this.body || pair.bodyB === this.body) {
                const otherBody = pair.bodyA === this.body ? pair.bodyB : pair.bodyA;

                if(otherBody.isSensor) return;
                // Check if collision is from below the player (feet)
                const playerBottom = this.body.bounds.max.y;
                const otherTop = otherBody.bounds.min.y;
                
                if (Math.abs(playerBottom - otherTop) < 30) {
                    this.toggleAnim(this.anims.idle);
                    this.grounded = true;
                    onGrounded();
                    this.jumping = false;
                }
                // if (Matter.Collision.collides(pair.bodyA, pair.bodyB)) {
                //     this.grounded = true;
                //     this.jumping = false;
                // }
                

                }
            }
        });
        
        Matter.Events.on(this.engine, 'collisionEnd', (event) => {
            const pairs = event.pairs;
            
            for (const pair of pairs) {
                if (pair.bodyA === this.body || pair.bodyB === this.body) {
                    // Set a short timeout to check if player is still grounded
                    setTimeout(() => {
                        const contacts = Matter.Query.collides(this.body, this.engine.world.bodies);
                        if (contacts.length === 0) {
                            this.grounded = false;
                        }
                    }, 50);
                }
            }
        });
    }

    update() {
        // Update player position based on physics body
        this.container.position.set(
            this.body.position.x - this.size / 2,
            this.body.position.y - this.size / 2
        );
    }

    handleMovement(soundLevel) {
        // Check if we're allowed to move (this would be false during countdown)
        if (!window.gameStarted) {
            Matter.Body.setVelocity(this.body, { 
                x: 0, 
                y: this.body.velocity.y 
            });
            return;
        }
        
        // Jump stuff
        if (this.allowJump && soundLevel >= this.config.sound.threshold.jump && this.grounded && !this.jumping) {
            this.jump(this.config.jumpForce);
            this.soundBarRoar();
        } 
        // Walk stuff
        else if (this.allowMove && soundLevel >= this.config.sound.threshold.slowWalk) {
            let maxSpeedSoundThreshold = this.config.sound.threshold.walk;
            let minSpeedSoundThreshold = this.config.sound.threshold.slowWalk;
            let moveSpeed = (soundLevel - minSpeedSoundThreshold) / maxSpeedSoundThreshold - minSpeedSoundThreshold;
            moveSpeed = Math.max(0, Math.min(moveSpeed, 1)); // Clamp between 0 and 1
            this.setAnimSpeed(moveSpeed);
            this.move(this.config.playerSpeed * moveSpeed);
        } else {
            // Stand still (no sound)
            if(!this.jumping && this.grounded)
                this.toggleAnim(this.anims.idle);

            Matter.Body.setVelocity(this.body, { 
                x: 0, 
                y: this.body.velocity.y 
            });
        }
    }

    soundBarRoar() {
        // lionRoar.then(async (images) => {
        //     console.log("start roaring!!")
        //     for(let i = 0; i < images.length; i++) {
        //         // if(!this.jumping) return;
        //         console.log("roaring!!")
        //         this.soundHead.style.backgroundImage = `url('${images[i]}')`
        //         await pause(15);
        //     }
        // })
    }

    move(force) {
        if(!this.jumping)
            this.toggleAnim(this.anims.walk);

        Matter.Body.setVelocity(this.body, { 
            x: force, 
            y: this.body.velocity.y 
        });
    }

    jump(force) {
        // Jump (loud sound)
        this.allowMove = true;
        this.toggleAnim(this.anims.jump);

        Matter.Body.setVelocity(this.body, { 
            x: this.body.velocity.x, 
            y: force,
        });
        this.jumping = true;
        this.grounded = false;
        let roarIndex = Math.ceil( Math.random() * 4 );
        loader.Sound(`roar${roarIndex}`).play({volume: 2});
        loader.Sound("jump").play({volume: 2});
    }

    setAnimSpeed(speed) {
        if(this.curAnim) this.curAnim.setAnimSpeed(speed);
    }

    toggleAnim(anim) {
        if(this.curAnim === anim) return;
        if(this.curAnim) this.curAnim.stop();
        this.curAnim = anim;
        this.curAnim.play();
    }

    isOffScreen() {
        return this.body.position.y > this.config.height + this.size * 2;
    }

    reset(adjust) {
        // Reset position
        let posX = adjust ? 
            adjust + this.initialX + this.size / 2:
            this.initialX + this.size / 2;

        Matter.Body.setPosition(this.body, {
            x: posX,
            y: this.initialY + this.size / 2
        });
        
        // Reset velocity
        Matter.Body.setVelocity(this.body, { x: 0, y: 0 });
        
        // Reset state
        this.jumping = false;
        this.grounded = false;
    }

    cleanup() {
        if (this.container) {
            this.app.stage.removeChild(this.container);
        }
        
        if (this.body) {
            Matter.Composite.remove(this.engine.world, this.body);
        }
        
        // Remove collision event listeners
        // This seems to turn off ALL collisions, even if I turn them on elsewhere
        // Matter.Events.off(this.engine, 'collisionStart');
        // Matter.Events.off(this.engine, 'collisionEnd');
    }
}

export default Player;